import { Illustration, PageHeaderWrapper, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { DeprecatedGlobalAppV1Paths } from "@src/appV2/App/paths";
import { SupportContext } from "@src/appV2/support/constants";
import { HowToContactSupportLink } from "@src/appV2/support/HowToContactSupportLink";
import { useHistory } from "react-router-dom";

import { Button } from "../../components/Button";
import { PageHeaderTopRow } from "../../components/PageHeaderTopRow";
import { PageWrapper } from "../../components/PageWrapper";

export function DocumentsEmptyLicensesPage() {
  const history = useHistory();

  return (
    <PageWrapper variant="tertiary">
      <PageHeaderWrapper variant="tertiary">
        <PageHeaderTopRow />
      </PageHeaderWrapper>

      <Stack
        direction="column"
        spacing={10}
        sx={{
          padding: 5,
          flex: 1,
          textAlign: "center",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Stack spacing={7} alignItems="center">
          <Illustration type="error" />

          <Text variant="h4">
            Once you have added a license we’ll be able to show you the required documents
          </Text>

          <Button
            onClick={() => {
              history.push(DeprecatedGlobalAppV1Paths.LICENSE_MANAGER);
            }}
          >
            Click here to view your licenses
          </Button>
        </Stack>

        <Stack spacing={3} alignItems="center">
          <Text>If you keep having trouble, please reach out to our Support team.</Text>

          <HowToContactSupportLink supportContext={SupportContext.DOCUMENTS_ERROR} />
        </Stack>
      </Stack>
    </PageWrapper>
  );
}
